/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  ExpirableLRUStorage.ts
 */

import { ExpirableLRU, type ExpirableLRUOptions } from '@zcode/expirable-lru'
import { MapStorage } from './MapStorage'
import { getStorageKey } from './helpers/getStorageKey'
import type { ExpirableStorage } from './types/ExpirableStorage'
import type { ExpirableStorageOptions } from './types/ExpirableStorageOptions'

export type ExpirableLRUStorageOptions<TValue = any> = ExpirableStorageOptions &
  ExpirableLRUOptions<string, TValue>

export class ExpirableLRUStorage<TValue = any>
  extends MapStorage<TValue, ExpirableLRU<string, TValue>>
  implements ExpirableStorage<TValue>
{
  constructor(options: ExpirableLRUStorageOptions<TValue>) {
    super(
      { name: options.name, keySeparator: options.keySeparator },
      new ExpirableLRU(options)
    )
  }

  getExpiresInMs(key: string) {
    return this.map.getExpiresInMs(getStorageKey(key, this.options))
  }

  setItem(key: string, value: TValue, ttl?: number) {
    this.map.set(getStorageKey(key, this.options), value, ttl)
  }
}
